import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import * as Material from "@angular/material";

@NgModule({
  exports: [
    CommonModule,
    Material.MatAutocompleteModule,
    Material.MatBadgeModule,
    Material.MatBottomSheetModule,
    Material.MatButtonModule,
    Material.MatButtonToggleModule,
    Material.MatCardModule,
    Material.MatCheckboxModule,
    Material.MatChipsModule,
    Material.MatDatepickerModule,
    Material.MatDialogModule,
    Material.MatDividerModule,
    Material.MatExpansionModule,
    Material.MatGridListModule,
    Material.MatIconModule,
    Material.MatInputModule,
    Material.MatListModule,
    Material.MatMenuModule,
    Material.MatNativeDateModule,
    Material.MatPaginatorModule,
    Material.MatProgressBarModule,
    Material.MatProgressSpinnerModule,
    Material.MatRadioModule,
    Material.MatRippleModule,
    Material.MatSelectModule,
    Material.MatSidenavModule,
    Material.MatSliderModule,
    Material.MatSlideToggleModule,
    Material.MatSnackBarModule,
    Material.MatSortModule,
    Material.MatStepperModule,
    Material.MatTableModule,
    Material.MatTabsModule,
    Material.MatToolbarModule,
    Material.MatTooltipModule,
    Material.MatTreeModule
  ],
  declarations: []
})
export class AngularMaterialModule {}
